import React from 'react';
import styled from 'styled-components';

const Title = styled.div<{ korean: boolean }>`
	${({ korean }) =>
		korean
			? `
    font-size: 2rem;
    font-weight: 700;
    margin: 5rem auto 3rem;
  `
			: `
    font-size: 3rem;
    margin: 4rem auto;
  `}

	display: flex;
	align-items: center;
	justify-content: center;

	@media (max-width: 767px) {
		font-size: ${({ korean }) => (korean ? '1.8rem' : '2.5rem')};
		margin: ${({ korean }) => (korean ? '3.6rem auto 2rem' : '3rem auto 1rem')};
	}

	@media (min-width: 768px) and (max-width: 1023px) {
		margin: ${({ korean }) => (korean ? '5rem auto 3rem' : '4rem auto 2rem')};
	}
`;

interface PageTitleProps {
	children: React.ReactNode;
	korean?: boolean;
}

function PageTitle({ children, korean = false }: PageTitleProps): React.ReactElement {
	return <Title korean={korean}>{children}</Title>;
}

export default PageTitle;
